// utils/planosMapper.js

/**
 * Mapea la nueva estructura de datos a la estructura esperada por los componentes
 * @param {Object} plano - Plano con la nueva estructura
 * @returns {Object} - Plano con la estructura adaptada
 */
export const mapPlanoToOldStructure = (plano) => {
    return {
        id: plano.id?.toString() || plano.identity || '',
        slug: plano.name?.toLowerCase().replace(/\s+/g, '-') || '',
        titulo: plano.name || '',
        categoria: plano.category || 'Sin categoría',
        descripcion: plano.description || '',
        descripcionCompleta: plano.description || '',
        areaTerreno: plano.dimencion ? `${plano.front} x ${plano.depth}` : 'N/A',
        areaConstruida: plano.area ? `${plano.area} m²` : 'N/A',
        ambientes: plano.rooms ? `${plano.rooms} ambientes` : 'N/A',
        imagenes: plano.images || ['/images/placeholder-plan.jpg'],
        driveId: plano.driveId || '',
        // Campos adicionales que podrían ser útiles
        categoriaOriginal: plano.category,
        area: plano.area,
        rooms: plano.rooms,
        floors: plano.floors,
        front: plano.front,
        depth: plano.depth,
        price: plano.price,
        type: plano.type,
        formats: plano.formats,
        includes: plano.includes,
        style: plano.style,
        level: plano.level
    };
};

/**
 * Mapea múltiples planos
 * @param {Array} planos - Array de planos con nueva estructura
 * @returns {Array} - Array de planos con estructura adaptada
 */
export const mapPlanoListToOldStructure = (planos) => {
    return planos.map(mapPlanoToOldStructure);
};